import { Reducer } from 'redux'
import { v4 as uuid4 } from 'uuid'
import {
  type ListingCardCreationAction,
  type ListingCardInCreation,
  initialListingCardInCreationState,
} from './types'

export * from './types'

export const reducer: Reducer<
  ListingCardInCreation,
  ListingCardCreationAction
> = (state = initialListingCardInCreationState, action) => {
  // Use string literals to avoid issues with enum being undefined in test environments
  // The enum values are: 'SET_CREATE_LISTING_DATA', 'SET_SELECTED_TEMPLATE_ID', etc.
  switch (action?.type) {
    case 'SET_CREATE_LISTING_DATA': {
      return {
        ...state,
        listingCardData: {
          ...state.listingCardData,
          ...action.payload,
        },
      }
    }
    case 'SET_SELECTED_TEMPLATE_ID': {
      return {
        ...state,
        listingCardData: {
          ...state.listingCardData,
          templateId: action.payload,
        },
      }
    }
    case 'SET_TEMPLATE_ON_LISTING': {
      const { id, name, ...rest } = action.payload
      return {
        ...state,
        listingCardData: {
          ...state.listingCardData,
          template: {
            id: id,
            name: name,
            data: { ...rest },
          },
        },
      }
    }
    case 'CLEAR_LISTING_CARD_DATA': {
      return {
        ...initialListingCardInCreationState,
        listingCardData: {
          ...initialListingCardInCreationState.listingCardData,
          product: [
            {
              uniqueId: String(uuid4()),
              url: '',
              isOpen: true,
              isLoading: false,
            },
          ],
        },
      }
    }
    default: {
      return state
    }
  }
}
